/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum ModelInvocationStatus {
	Unknown = 'unknown',
	Ok = 'ok',
	RuntimeError = 'runtimeError',
	DeclinedHarmful = 'declinedHarmful',
	DeclinedMisuse = 'declinedMisuse',
	DeclinedUnknown = 'declinedUnknown',
	DeclinedInputTooLong = 'declinedInputTooLong',
}

export interface ProblemDetails {
	type?: string | null;
	title?: string | null;
	/** @format int32 */
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
	[key: string]: any;
}

export interface QnAAnswer {
	statements: Statement[];
	references?: Reference[] | null;
}

export interface QnAContextMessage {
	/** @minLength 1 */
	request: string;
	response?: QnAAnswer;
	/** @format date-time */
	createdAt: string;
	/** @format date-time */
	updatedAt: string;
	/** @minLength 1 */
	taskId: string;
	status: QnAContextMessageStatus;
	/** @format date-time */
	expiry: string;
	result?: ModelInvocationStatus;
	errorMessage?: string | null;
	/** @example "sharefile:account-123" */
	contextRID?: string | null;
}

export enum QnAContextMessageStatus {
	Pending = 'pending',
	Completed = 'completed',
	Failed = 'failed',
}

export interface QnACtx {
	/**
	 * Unique identifier of the resource.
	 * @example "sharefile:account-123"
	 */
	RID?: string | null;
	/**
	 * A timestamp for when the resource was created.  This value is set internally and cannot be modified.
	 * @format date-time
	 */
	createdAt?: string | null;
	/**
	 * A timestamp for when the resource was last updated.  This value is set internally and cannot be modified.
	 * @format date-time
	 */
	updatedAt?: string | null;
	/**
	 * Unique identifier of the User that created the resource.  This value is set internally and cannot be modified.
	 * @example "sharefile:account-123"
	 */
	creatorRID?: string | null;
	/**
	 * Unique identifier of the User that last updated the resource.  This value is set internally and cannot be modified.
	 * @example "sharefile:account-123"
	 */
	updaterRID?: string | null;
	/**
	 * A timestamp that identifies when the next lifecycle state change should occur.
	 * @format date-time
	 */
	expiresAt?: string | null;
	/** The current lifecycle state of the resource.  This value is set internally and cannot be modified. */
	lifecycleState?: 'active' | 'recycleBin' | 'purged' | null;
	/** @example "sharefile:account-123" */
	sourceResourceId: string;
	/** @format date-time */
	expiry: string;
	messages: QnAContextMessage[];
}

/** This object is utilized by the paged API calls to return a list of resources and the next skip value. */
export interface QnACtxResourcePagedResult {
	/**
	 * The skip value that should be passed to get the next sequential page of resources.
	 * @format int32
	 */
	nextSkip?: number | null;
	/** The page of resources that were found. */
	resources?: QnACtx[] | null;
}

export interface QnAQuestion {
	/** @example "sharefile:account-123" */
	sourceRID?: string | null;
	request?: string | null;
}

export interface Reference {
	/** @minLength 1 */
	reference_sentence: string;
	/**
	 * @format int32
	 * @min 0
	 * @max 2147483647
	 */
	reference_number: number;
	context_sentence_before?: string | null;
	context_sentence_after?: string | null;
}

/** The type of authentication to use when authenticating. */
export enum ShareFileAuthType {
	User = 'user',
	System = 'system',
}

export interface Statement {
	/** @minLength 1 */
	sentence: string;
	reference_numbers?: number[] | null;
}

export interface ValidationProblemDetails {
	type?: string | null;
	title?: string | null;
	/** @format int32 */
	status?: number | null;
	detail?: string | null;
	instance?: string | null;
	errors?: Record<string, string[]>;
	[key: string]: any;
}
